import IconoInstagram from './IconoInstagram';
import { cierre, contacto } from '../data/contenido';

export default function Contacto() {
  return (
    <section className="contacto" id="contacto">
      <div className="envoltura">
        <h2 className="contacto__titulo" data-reveal="">
          {cierre.titulo}
        </h2>
        <p data-reveal="" style={{ '--retraso': '110ms' }}>
          {cierre.texto}
        </p>

        <div className="contacto__vias" data-reveal="" style={{ '--retraso': '200ms' }}>
          <a className="via" href={contacto.instagramUrl} target="_blank" rel="noreferrer">
            Escríbeme por Instagram
            <IconoInstagram />
          </a>
          <a className="via via--tenue" href={`mailto:${contacto.correo}`}>
            {contacto.correo}
          </a>
        </div>

        <ul className="contacto__horario" data-reveal="" style={{ '--retraso': '280ms' }}>
          {contacto.horario.map((linea) => (
            <li key={linea}>{linea}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
